(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(fmt, cents) { var v = cents / 100; return fmt ? fmt.format(v) : (Math.round(v) + ' kr'); }
  function initBundle(bundle) {
    var checks = bundle.querySelectorAll('[data-fbt-check]');
    var totalEl = bundle.querySelector('[data-fbt-total]');
    var addBtn = bundle.querySelector('[data-fbt-add]');
    var currency = bundle.getAttribute('data-currency') || 'SEK';
    var fmt = null;
    try { fmt = new Intl.NumberFormat('sv-SE', { style: 'currency', currency: currency, maximumFractionDigits: 0 }); } catch (e) {}

    function updateTotal() {
      var cents = 0;
      checks.forEach(function (c) { if (c.checked) { cents += parseInt(c.getAttribute('data-price'), 10) || 0; } });
      if (totalEl) { totalEl.textContent = money(fmt, cents); }
    }
    checks.forEach(function (c) {
      c.addEventListener('change', function () {
        var item = c.closest('[data-fbt-item]');
        if (item) { item.classList.toggle('is-dimmed', !c.checked); }
        updateTotal();
      });
    });
    bundle.querySelectorAll('[data-fbt-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        var item = sel.closest('[data-fbt-item]');
        var check = item.querySelector('[data-fbt-check]');
        var priceEl = item.querySelector('[data-fbt-price]');
        var price = parseInt(opt.getAttribute('data-price'), 10) || 0;
        check.setAttribute('data-variant-id', opt.value);
        check.setAttribute('data-price', price);
        if (priceEl) { priceEl.textContent = money(fmt, price); }
        updateTotal();
      });
    });
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [];
        checks.forEach(function (c) { if (c.checked) { items.push({ id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 }); } });
        if (!items.length) { return; }
        addBtn.classList.add('is-loading');
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = root + 'cart'; })
          .catch(function () { addBtn.classList.remove('is-loading'); });
      });
    }
    updateTotal();
  }
  function boot() { document.querySelectorAll('[data-bundle]').forEach(initBundle); }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var drawer = document.querySelector('[data-drawer]');
  var drawerToggle = document.querySelector('[data-drawer-toggle]');

  function openDrawer() {
    if (!drawer) { return; }
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
    if (drawerToggle) { drawerToggle.setAttribute('aria-expanded', 'true'); }
  }
  function closeDrawer() {
    if (!drawer) { return; }
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    if (drawerToggle) { drawerToggle.setAttribute('aria-expanded', 'false'); }
  }
  if (drawerToggle) {
    drawerToggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
    });
  }
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  var more = document.querySelector('[data-more]');
  var moreToggle = document.querySelector('[data-more-toggle]');
  if (more && moreToggle) {
    moreToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = more.classList.toggle('is-open');
      moreToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!more.contains(e.target)) {
        more.classList.remove('is-open');
        moreToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      if (more) { more.classList.remove('is-open'); if (moreToggle) { moreToggle.setAttribute('aria-expanded', 'false'); } }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  function boot() {
    var vids = document.querySelectorAll('[data-step-video]');
    if (!vids.length) { return; }
    function play(v) { v.muted = true; var p = v.play(); if (p && p.catch) { p.catch(function () {}); } }
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(vids, play);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { play(e.target); } else { e.target.pause(); }
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-cart-section]');
  if (!root) { return; }
  var sectionId = root.getAttribute('data-section-id');
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  function setCount(n) {
    var el = document.querySelector('.header__cart-count');
    if (el) { if (n > 0) { el.textContent = n; el.style.display = ''; } else { el.style.display = 'none'; } }
  }

  function updateQty(key, qty) {
    root.classList.add('is-loading');
    fetch(routeRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: sectionId, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.sections && cart.sections[sectionId]) {
          var doc = new DOMParser().parseFromString(cart.sections[sectionId], 'text/html');
          var fresh = doc.querySelector('[data-cart-section]');
          if (fresh) { root.innerHTML = fresh.innerHTML; } else { window.location.reload(); return; }
          setCount(cart.item_count);
          root.classList.remove('is-loading');
        } else {
          window.location.reload();
        }
      })
      .catch(function () { window.location.reload(); });
  }

  root.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) { return; }
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) { qty = 0; }
    updateQty(input.getAttribute('data-key'), qty);
  });

  root.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-remove]');
    if (minus || plus) {
      var wrap = (minus || plus).closest('.cart-qty');
      var input = wrap.querySelector('[data-qty-input]');
      var qty = parseInt(input.value, 10) || 0;
      qty = minus ? Math.max(0, qty - 1) : qty + 1;
      input.value = qty;
      updateQty(input.getAttribute('data-key'), qty);
    } else if (remove) {
      e.preventDefault();
      updateQty(remove.getAttribute('data-key'), 0);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function activate(container, tab) {
    var targetId = tab.getAttribute('data-tab-target');
    container.querySelectorAll('[data-tab-target]').forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    container.querySelectorAll('[data-tab-panel]').forEach(function (p) {
      p.hidden = (p.id !== targetId);
    });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-tab-target]');
    if (!tab) { return; }
    var container = tab.closest('[data-catalog-tabs]');
    if (container) { activate(container, tab); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') { return; }
    var tab = e.target.closest && e.target.closest('[data-tab-target]');
    if (!tab) { return; }
    var container = tab.closest('[data-catalog-tabs]');
    if (!container) { return; }
    var tabs = Array.prototype.slice.call(container.querySelectorAll('[data-tab-target]'));
    var i = tabs.indexOf(tab);
    var next = e.key === 'ArrowRight' ? (tabs[i + 1] || tabs[0]) : (tabs[i - 1] || tabs[tabs.length - 1]);
    if (next) { next.focus(); activate(container, next); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function initVariants(section) {
    var dataEl = section.querySelector('[data-variants]');
    if (!dataEl) { return; }
    var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selectors = section.querySelectorAll('[data-option-selector]');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var addBtn = section.querySelector('[data-add]');
    var addText = section.querySelector('[data-add-text]');
    var addLabel = addBtn ? (addBtn.getAttribute('data-add-label') || '') : '';
    function chosen() { return Array.prototype.map.call(selectors, function (s) { return s.value; }); }
    function findVariant() {
      if (!selectors.length) { return variants[0]; }
      var sel = chosen();
      return variants.find(function (v) { return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; }); });
    }
    function update() {
      var v = findVariant();
      if (!v) { if (addBtn) { addBtn.disabled = true; } if (addText) { addText.textContent = 'Ej tillgänglig'; } return; }
      if (idInput) { idInput.value = v.id; }
      if (priceEl) { priceEl.textContent = v.price; }
      if (compareEl) { if (v.compare_at && v.compare_at !== '' && v.compare_at !== v.price) { compareEl.textContent = v.compare_at; compareEl.hidden = false; } else { compareEl.hidden = true; } }
      if (addBtn) { addBtn.disabled = !v.available; }
      if (addText) { addText.textContent = v.available ? addLabel : 'Slutsåld'; }
      if (window.history && history.replaceState) { try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString()); } catch (e) {} }
    }
    Array.prototype.forEach.call(selectors, function (s) { s.addEventListener('change', update); });
  }

  function initGallery(section) {
    var track = section.querySelector('[data-gallery-track]');
    if (!track) { return; }
    var slides = track.querySelectorAll('[data-gallery-slide]');
    var thumbs = section.querySelectorAll('[data-thumb]');
    var prev = section.querySelector('[data-gallery-prev]');
    var next = section.querySelector('[data-gallery-next]');
    if (slides.length < 2) { return; }
    function goTo(i) { i = Math.max(0, Math.min(i, slides.length - 1)); var s = slides[i]; track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    function currentIndex() {
      var center = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
      Array.prototype.forEach.call(slides, function (s, i) { var c = s.offsetLeft - track.offsetLeft + s.clientWidth / 2; var d = Math.abs(c - center); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function setActive(i) { Array.prototype.forEach.call(thumbs, function (t, ti) { t.classList.toggle('is-active', ti === i); }); }
    Array.prototype.forEach.call(thumbs, function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); }); });
    if (prev) { prev.addEventListener('click', function () { goTo(currentIndex() - 1); }); }
    if (next) { next.addEventListener('click', function () { goTo(currentIndex() + 1); }); }
    var tmr;
    track.addEventListener('scroll', function () { clearTimeout(tmr); tmr = setTimeout(function () { setActive(currentIndex()); }, 80); }, { passive: true });
    setActive(0);
  }

  function boot() { document.querySelectorAll('[data-product-section]').forEach(function (s) { initVariants(s); initGallery(s); }); }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMarquee(m) {
    var track = m.querySelector('[data-rev-track]');
    if (!track) { return; }
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }

    var setWidth = track.scrollWidth;
    if (setWidth <= 0) { return; }

    m.classList.add('is-animating');

    // Duplicera innehållet tills bandet är brett nog för sömlös loop
    var original = track.innerHTML;
    var guard = 0;
    while (track.scrollWidth < m.clientWidth + setWidth + 60 && guard < 12) {
      track.insertAdjacentHTML('beforeend', original);
      guard++;
    }

    var speed = parseFloat(m.getAttribute('data-speed')) || 5;   // 1–10
    var pxPerSec = speed * 12;                                    // 5 => 60 px/s
    var durationMs = (setWidth / pxPerSec) * 1000;
    var ltr = m.getAttribute('data-direction') === 'ltr';
    var frames = ltr
      ? [{ transform: 'translateX(-' + setWidth + 'px)' }, { transform: 'translateX(0)' }]
      : [{ transform: 'translateX(0)' }, { transform: 'translateX(-' + setWidth + 'px)' }];

    var anim = track.animate(frames, { duration: durationMs, iterations: Infinity, easing: 'linear' });

    if (m.getAttribute('data-pause-hover') === 'true') {
      m.addEventListener('mouseenter', function () { anim.pause(); });
      m.addEventListener('mouseleave', function () { anim.play(); });
    }
  }
  function boot() { document.querySelectorAll('[data-rev-marquee]').forEach(initMarquee); }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-atc"]) return;
  try {
    
(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) { return; }
  var target = document.querySelector('[data-product-section]');
  function show() { bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false'); }
  function hide() { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); }
  if (target && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { hide(); }
        else if (e.boundingClientRect.top < 0) { show(); }
      });
    }, { threshold: 0 });
    io.observe(target);
  } else {
    window.addEventListener('scroll', function () { if (window.scrollY > 700) { show(); } else { hide(); } }, { passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function playMuted(v) {
    v.muted = true; v.setAttribute('muted', '');
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  }
  function boot() {
    var vids = [];
    document.querySelectorAll('[data-video-banner] [data-video]').forEach(function (v) { vids.push(v); });
    if (!vids.length) { return; }
    // Spela bara videon som syns – då försöker aldrig flera autospela samtidigt
    // (det är annars det som får mobilen att kräva ett tryck).
    if (!('IntersectionObserver' in window)) { vids.forEach(playMuted); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { playMuted(e.target); }
        else { try { e.target.pause(); } catch (err) {} }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

  } catch(e) { console.error(e); }
})();
})();
